import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-loading',
  templateUrl: 'loading.component.html',
  styleUrls:  ['loading.component.css']
})
export class LoadingComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LoadingComponent>, @Inject(MAT_DIALOG_DATA) public data:string) { 

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

  }
      
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/loading/loading.component.ts